//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin"

export default BaseCmsBlock.extend({
  name: "CountriesBlock",

  data: function () {
    return {
      search: ""
    }
  },

  computed: {
    countries: function () {
      return this.$store?.state?.["countries"]?.countriesList || []
    },
    countriesItems: function () {
      const search = String(this.search || '').toLowerCase();
      if (search.length <= 1) {
        return this.countries
      }
      return [...(this.countries || [])]
        .filter((service) => {
          const isName = Boolean(String(service?.name || '').toLowerCase().includes(search));
          const isSlug = Boolean(String(service?.slug || '').toLowerCase().includes(search));
          const isSynonyms = Boolean((service?.synonymsList || []).find((t) => String(t || '').includes(search)));

          return Boolean(isName || isSlug || isSynonyms);
        });
    }
  }
});
